import React, { useState } from 'react'
import {
    EditButton,
    DeleteButton,
    List,
    Datagrid,
    TextField,
    ReferenceField,
    DateField,
    FunctionField,
} from 'react-admin'
import { TextField as TextInput, Button as Submit } from '@material-ui/core'

const RecordingList = (props) => {
    const [filter, setFilter] = useState('')
    return (
        <>
            <p style={{ margin: 0 }}>
                Click on any field header to sort by that field
            </p>
            <Filter setFilter={setFilter} />
            <List
                {...props}
                sort={{ field: 'createdAt', order: 'DESC' }}
                filter={{
                    key: filter,
                    fields: ['title', 'description', 'tags.tagName'],
                }}
            >
                <Datagrid rowClick="edit">
                    <TextField source="title" />
                    <FunctionField
                        label="Description"
                        render={(record) => trimText(record?.description, 60)}
                    />
                    <FunctionField
                        label="Path"
                        render={(record) => {
                            const path =
                                record?.tempResourceUrl ||
                                record?.azureResourceUrl ||
                                record?.path ||
                                record?.url ||
                                '-'
                            return <span title={path}>{getPathLabel(path)}</span>
                        }}
                    />
                    <ReferenceField source="uploaderId" reference="users">
                        <TextField source="name" />
                    </ReferenceField>
                    <DateField source="createdAt" label="Upload Date" />
                    <EditButton />
                    <DeleteButton />
                    <RecordingLinkField />
                </Datagrid>
            </List>
        </>
    )
}

const trimText = (value, maxLen) => {
    if (!value) return '-'
    if (value.length <= maxLen) return value
    return `${value.slice(0, maxLen)}...`
}

const getPathLabel = (path) => {
    if (!path) return '-'
    const parts = path.split('/')
    const fileName = parts[parts.length - 1]
    return trimText(fileName || path, 40)
}

const Filter = (props) => {
    const [value, setValue] = useState('')
    return (
        <p style={{ margin: 0 }}>
            Filter by title, description, tags:{' '}
            <TextInput
                value={value}
                onChange={(e) => setValue(e.target.value)}
            />
            <Submit onClick={() => props.setFilter(value)} color="primary">
                Apply
            </Submit>
        </p>
    )
}

const RecordingLinkField = ({ record = {} }) => {
    return (
        <a
            href={`/recording/${record.id}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            View
        </a>
    )
}

export default RecordingList
